import { createUseStyles } from 'react-jss';

export const addKpiCategoryStyles = createUseStyles({
  container: {

  },
});
